import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faLockAlt } from '@fortawesome/pro-solid-svg-icons/faLockAlt';

library.add(faEnvelope as IconDefinition, faLockAlt as IconDefinition);

Vue.component('FontAwesome', FontAwesomeIcon);
